// Material UI
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

import brands from "../../../Utilities/Brands";


const GenerateOptOutSearchFormPhone = (
  brandId,
  setBrandId,
  phoneNumber,
  setPhoneNumber
) => {

  const formatPhoneNumber = (input) => {
    const cleanedInput = input.replace(/\D/g, '');

    if (cleanedInput.length <= 10) {
      let formattedPhoneNumber = `(${cleanedInput.slice(0, 3)}`;

      if (cleanedInput.length > 3) {
        formattedPhoneNumber += `) ${cleanedInput.slice(3, 6)}`;
      }

      if (cleanedInput.length > 6) {
        formattedPhoneNumber += ` - ${cleanedInput.slice(6, 10)}`;
      }

      return formattedPhoneNumber;
    }

    return phoneNumber; // Don't modify if more than 10 digits
  };


  const formLabels = [
    {
      Label: "Brand",
      Element: "FormControl",
      Value: brandId,
      Setter: setBrandId,
      Data:
      <>
      <option value="" key="-1" />
      <option value="0" key="0">All</option>
        {brands.map((card, _idx) => {
          return (
            <option key={card._id} value={card._id}>
              {card.brand}
            </option>
          );
        })}
      </>
    },
    {
      Label: "Phone Number",
      Element: "TextField",
      Value: phoneNumber,
      Setter: setPhoneNumber,
      Type: "tel"
    }
  ];


  return formLabels.map(
    ({ Label, Element, Type, Data, Value, Setter }, idx) => {
      switch (Element) {
        case "TextField":
          return (
            <TextField
              key={idx}
              id="outlined-full-width"
              className="input-el"
              label={Label}
              type={Type}
              style={{ margin: 8, width: "14rem" }}
              fullWidth={false}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              value={Value}
              onChange={(e) => {
                  const inputPhoneNumber = e.target.value;
                  const formattedPhoneNumber = formatPhoneNumber(inputPhoneNumber);
                  Setter(formattedPhoneNumber)
                }
              }
            />
          );
        case "FormControl":
          return (
              <FormControl
                key={idx}
                variant="outlined"
                style={{ margin: 8, width: "14rem" }}
                value={Value}
                onChange={(e) => Setter(e.target.value)}
              >
                <InputLabel htmlFor="outlined-age-native-simple">
                  {Label}
                </InputLabel>
                <Select
                  native={true}
                  label={Label}
                  value={Value}
                  inputProps={{
                    name: `${Label.toLowerCase()}`,
                    id: `outlined-${Label.toLowerCase()}-native-simple`,
                  }}
                >
                  {Data}
                </Select>
              </FormControl>
            );
        default:
          return null;
      }
    }
  );
};

export default GenerateOptOutSearchFormPhone;
